function AvatarLetters(name) {
    let words = name.split(' ');
    let capitalizedWords = words.map(word => word.charAt(0).toUpperCase());
    console.log(capitalizedWords.join(''))
    return capitalizedWords.join('');
}
export default AvatarLetters